import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Phone } from 'lucide-react';
export function CTASection() {
  const {
    t
  } = useLanguage();
  return <section className="py-16 sm:py-20 bg-slate-900 text-white" id="contact" data-id="element-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-33">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6" data-id="element-34">
          {t('Ready to take the next step?', '¿Listo/a para el siguiente paso?')}
        </h2>
        <p className="text-base sm:text-xl text-slate-300 mb-8 sm:mb-10 max-w-2xl mx-auto" data-id="element-35">
          {t('Schedule a consultation to discuss options tailored to your medical history and goals.', 'Agenda una consulta para hablar de opciones según tu historial y tus objetivos.')}
        </p>

        <div className="flex justify-center" data-id="element-36">
          <a href="tel:4844084100" className="inline-flex items-center justify-center px-6 sm:px-8 py-3.5 sm:py-4 bg-[#0d9488] hover:bg-[#0f766e] text-white font-bold rounded-lg transition-all shadow-lg hover:shadow-[#0d9488]/40 hover:-translate-y-1 text-base sm:text-lg" data-id="element-37">
            <Phone className="w-5 h-5 mr-2 flex-shrink-0" data-id="element-38" />
            <span data-id="element-39">
              {t('To schedule a consult please call (484) 408-4100', 'Para agendar una consulta llame al (484) 408-4100')}
            </span>
          </a>
        </div>
      </div>
    </section>;
}